import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ISideSubmenu } from "../models/permission.model";
import { RootState } from "../store/rootReducer";

const useAuth = () => {
  const history = useHistory();
  const location = useLocation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { sidemenu } = useSelector((state: RootState) => state.sidemenu);

  const [urls, setUrls] = useState<string[]>();
  const [submenus, setSubmenus] = useState<ISideSubmenu[]>([]);
  const [writeAuthYn, setWriteAuthYn] = useState<'Y'|'N'>('N');

  useEffect(() => {
    if (sidemenu) {
      const _urls: string[] = ['/'];
      const _submenus: ISideSubmenu[] = [];

      sidemenu.forEach(menu => {
        _urls.push(menu.menuUrl);
        menu.secondaryMenu.forEach(submenu => {
          _urls.push(submenu.menuUrl);
          _submenus.push(submenu);
        });
      });
  
      setUrls(_urls);
      setSubmenus(_submenus);
    }
  }, [sidemenu]);

  useEffect(() => {
    // authGroupDiv S = 셔틀도우미
    if (urls && urls.length > 1 && auth.authGroupDiv !== 'S') {
      const pathnames = location.pathname.split('/');
      const path = pathnames.length >= 3
        ? `/${pathnames[1]}/${pathnames[2]}`
        : location.pathname;

      if (!urls.includes(path) &&
          !location.pathname.includes('/cbt/speaking-test/exam') &&
          !location.pathname.includes('/assess') &&
          !location.pathname.includes('/class/print-award') &&
          !location.pathname.includes('/event/attendance')) {
        history.push('/');
      }

      const currentMenu = submenus.find(menu => menu.menuUrl.includes(path));
      if (currentMenu) {
        setWriteAuthYn(currentMenu.writeAuthYn);
      }
    }
  }, [location, urls, auth]);

  return {
    writeAuthYn,
  };
}

export default useAuth;
